/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from "react";
import { Button, Modal } from "react-bootstrap";

// project imports
import store from "features/store";
import './MembershipModal.scss';
import { addDataLayer } from "shared/utils/utils";
import { connect } from "react-redux";

/* this will be shown after sigin as a notification alert */
class MembershipModal extends Component {

    componentDidMount = () => {
       setTimeout(() => {
            if(this.props.membershipModal.show) {
                store.dispatch({ type: 'MEMBERSHIP_MODAL', payload: { show: false } });
            }
       }, 10000); 
    }
    handleClose = () => {
        store.dispatch({ type: 'MEMBERSHIP_MODAL', payload: { show: false } });
    }

    joinToday = () => {
        if(this.props.history.location.pathname == '/my-account/join-premier-member') {
            store.dispatch({ type: 'MEMBERSHIP_MODAL', payload: { show: false } });
        } else {
            this.props.history.push("/plans");
            store.dispatch({ type: 'MEMBERSHIP_MODAL', payload: { show: false } });
        }
        let dataLayerData = {
            'event': 'join_premier',
            'title': 'Premier-PopAd-Homepage-UnlockPM1'
        }
        addDataLayer(dataLayerData);
    }

    render() {
        return (
            <Modal id="membership-modal-main" show={this.props.membershipModal.show} onHide={this.handleClose} animation={false} centered
                size="md" className=" animate__animated animate__fadeInUp" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Body>
                    <div className="d-flex flex-column align-items-center modal-pm">
                        <div className="clickable" onClick={this.joinToday}>
                            <img className="w-100" src="/static/logo/membershipModal.jpg" alt="premier-logo" />
                            <div className="member-btn">
                                <Button className="member-btn-join">Join Today!</Button>
                            </div>
                        </div>

                        <div className="modal-close-icon">
                            <div className="close-icon clickable" onClick={this.handleClose}>x</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default connect(state => state)(MembershipModal);